.size-chooser{width:225px}
/*# sourceMappingURL=superpixel-secondary-toolbar.component.css.map */
